export default {
    url: '/campaign',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 803,
        title: 'Progress By Days',
        role: 'economics',
    },
};
